// extracted by mini-css-extract-plugin
export default {"wrapper":"Wv-z","response":"Xv-z","error":"Yv-z","disabled":"Zv-z","buttons":"_v-z","feedbackQuestionSection":"aw-z","yesNoWrapper":"bw-z"};